import { Typography } from "antd";
import { useTranslation } from "react-i18next";

// Panduan hapus cache manual, tampil saat pemulihan chunk otomatis
// (utils/chunkRecovery) sudah menyerah. Label mengikuti Chrome.
// eslint-disable-next-line react/prop-types
export default function ClearCacheGuide({ buttonLabel }) {
  const { t } = useTranslation();
  const steps = [
    t("error_page.clear_cache_step_1"),
    t("error_page.clear_cache_step_2"),
    t("error_page.clear_cache_step_3"),
    t("error_page.clear_cache_step_4"),
  ];

  return (
    <div className="text-left">
      <Typography.Title level={5}>
        {t("error_page.clear_cache_title")}
      </Typography.Title>
      <Typography.Paragraph>
        {t("error_page.clear_cache_desc")}
      </Typography.Paragraph>
      <ol className="mb-3 list-decimal space-y-1 pl-5">
        {steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
      <Typography.Text type="secondary">
        {t("error_page.clear_cache_footer", { button: buttonLabel })}
      </Typography.Text>
    </div>
  );
}
